import { useEffect, useRef } from 'react'
import ReactCodeInput, { type ReactCodeInputProps } from 'react-code-input'
import { Cluster } from '@dlpco/fluid-layout'
import { theme } from 'shared/theming'
import styled, { css } from 'styled-components'

import { Text } from '~/domains/platform/design-system'

interface CodeInputProps extends ReactCodeInputProps {
  inputStyle?: React.CSSProperties
  error?: string
  type?: 'number' | 'text' | 'password' | 'tel'
  name: string
  /** Boxes menores/gap reduzido para caber num container estreito (ex.: dentro de um Modal). */
  compact?: boolean
}

const StyledReactCodeInput = styled(ReactCodeInput)<{ hasError: boolean; compact?: boolean }>`
  input {
    border: 1px solid ${theme.colors.mediumGray2};

    :nth-child(3) {
      margin-right: ${props => (props.compact ? '0.75rem' : '2rem')};
    }

    &:focus {
      border-color: ${theme.colors.primary};
      outline: none;
    }

    ${props =>
      props.hasError &&
      css`
        border-color: ${theme.colors.danger};
      `};
  }
`

const fields = 6
const CodeInput = ({ error, value, inputStyle, compact, ...restProps }: CodeInputProps) => {
  const codeRef = useRef<any>()

  useEffect(() => {
    if (value === '' && codeRef.current) {
      if (codeRef.current.textInput[0]) codeRef.current.textInput[0].focus()
      for (let i = 0; i < fields; i++) {
        codeRef.current.state.input[i] = ''
      }
    }
  }, [fields, value])

  //TODO: 58:11 jsx-a11y/no-autofocus
  return (
    <>
      <Cluster space={compact ? '0.5rem' : '1rem'} showOverflow>
        <StyledReactCodeInput
          {...restProps}
          value={String(value)}
          fields={fields}
          hasError={Boolean(error)}
          compact={compact}
          autoFocus
          inputStyle={{
            width: compact ? '2.75rem' : '4rem',
            borderRadius: '5px',
            fontSize: compact ? '1.5rem' : '2rem',
            height: compact ? '3.5rem' : '5rem',
            padding: compact ? '0.5rem' : '1rem',
            textAlign: 'center',
            ...inputStyle
          }}
          ref={codeRef}
        />
      </Cluster>
      {error && (
        <Text role="alert" color="red" data-testid="error" fontSize={1} pt={0} marginTop="4px">
          {error}
        </Text>
      )}
    </>
  )
}

export default CodeInput
